"use client";

import { useState, useEffect } from "react";
import ArrowUp from "lucide-react/dist/esm/icons/arrow-up";
import { track } from "@/lib/analytics";

export function BackToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        track({ event: "back_to_top_clicked" });
      }}
      aria-label="Back to top"
      className="fixed bottom-6 right-6 z-50 md:bottom-24 h-11 w-11 rounded-full bg-card border border-border shadow-md text-foreground hover:bg-muted hover:text-primary hover:border-primary/40 flex items-center justify-center transition-colors"
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
}
